import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { styled } from '@mui/material/styles';

const SectionWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#F9FAFB',
  padding: theme.spacing(8, 2),
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: '#111827',
  marginBottom: theme.spacing(4),
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -6,
    left: 0,
    width: 60,
    height: 3,
    backgroundColor: '#01B7EA',
    borderRadius: 2,
  },
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: '#01B7EA',
  minWidth: '32px',
}));

const CoreFunctions = () => {
  const functions = [
    'Works for enhancing an expanded space for CSOs operation in the Region through supporting functional Regional GO-CSOs Partnership Forums and other policy influencing mechanisms.',
    'Organizes and facilitates various policy dialogues, panel discussions, workshops, consultative and consensus building meetings, etc. among the state and non-state actors to lobby and advocate for actions of improvements and changes for the public good.',
    'Undertakes members’ capacity building activities like short-term trainings, technical advisory supports, facilitation of experience sharing and exposure visits, etc. that enhance the development effectiveness of member organizations; Supports members access to financial, material, and other resources from the legitimate sources.',
    'Carryout activities that contribute for peace and peace building, good governance, respect to human rights, and democratization process in the country in general and in the Oromia Regional State in particular.',
    'Promotes the democratization process in the country in general and in the Oromia National Regional State in particular through coordination of members in the civic and voters education, organization of election debates, election observation, and election monitoring and evaluation activities.',
    'Facilitates information exchange among member organizations on issues pertinent to members and the wider CSO sector.',
    'Conducts researches on different topically pertinent issues for evidence-based policy dialogues and constructive interface between the Regional Government and the CSOs, and also among the wider development actors and the public at large.',
    'Facilitates members’ collective engagements and mutual learning through nurturing thematic forums.',
    'Facilitates conditions for member organizations to express their position of concerns/supports with regard to policies issued and actions taken by the Government.',
    'Undertakes activities that enhance members’ Ethical Standards and encourage them to undertake their activities in a transparent and accountable manner to the people that they serve. Put in place members’ self-regulation and adherence mechanisms and take necessary measures in line with this Memorandum of Association and the NeCSOO Code of Conduct.',
    'Coordinates and support members’ engagements in the humanitarian response, development, and advocacy activities.',
    'Undertakes other related activities that are meant to address the concern and interest of member organizations and the people of the Oromia National Regional State.',
  ];

  return (
    <SectionWrapper>
      <Container maxWidth="lg">
        <Title variant="h4">Core Functions of the Network</Title>
        <Paper elevation={0} sx={{ p: 3, backgroundColor: '#fff' }}>
          <List>
            {functions.map((item, index) => (
              <ListItem key={index} alignItems="flex-start">
                <StyledListItemIcon>
                  <CheckCircleIcon />
                </StyledListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="body1" sx={{ color: '#374151', lineHeight: 1.7 }}>
                      {item}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Container>
    </SectionWrapper>
  );
};

export default CoreFunctions;
